(ns hai-model.malli-registry
  (:require
   [humbleai.belt.malli.type.domain :as domain]
   [humbleai.belt.malli.type.email :as email]
   [humbleai.belt.malli.type.schema :as schema]
   [malli.core :as m]
   [malli.experimental.time :as met]
   [malli.registry :as mr]))

(mr/set-default-registry!
 (mr/composite-registry
  (m/default-schemas)
  domain/type
  email/type
  schema/type
  (met/schemas)))
